import _ from 'underscore';
import Radio from 'backbone.radio';
import NavCollection  from '@/collections/nav/nav';
import NavItemView from '@/views/nav/item';
import NavView  from '@/views/nav/view';
import Handlebars from 'handlebars';

function show_profile_nav(options) {
    var globalCh = Radio.channel('global');
    const nav_collection = new NavCollection();
    let collection;
    const app_layout = globalCh.request('app_layout');
    const region = app_layout.getRegion('profile_nav');
    const primary = globalCh.request('primary_account');

    var nav_item_view = NavItemView.extend({
        template: Handlebars.compile('<i class="{{icon}}" data-id="{{id}}"></i><a class="{{class}}">{{title}}</a>'),
        templateContext: function() {
            return {
                show_count: this.model.get('show_count') || false,
                count: this.model.get('count') || false
            };
        } 
    });

    options = options || {};

    options = _.extend({
        collection: nav_collection,
        category: 'profile-nav',
        childView: nav_item_view
    }, options);

    var nav_items = [
        {
            id: 'profile-home',
            title: 'Profile',
            icon: 'fa fa-user',
            text: 'Profile',
            class: 'profile-home',
            selected: options.selected == 'profile-home',
            action: function show_profile() {
                globalCh.request('show_profile', primary);
            }
        },
        {
            id: 'login-keys',
            title: 'Login Keys',
            icon: 'fa fa-key',
            text: 'Login Keys',
            class: 'login-keys',
            selected: options.selected == 'login-keys',
            action: function show_login_keys() {
                globalCh.request('show_login_keys', primary);
            }
        }
    ];

    var features = globalCh.request('app_options', 'features');

    if (features.show_mfa) {
        nav_items.splice(1, 0, {
            id: 'mfa',
            title: 'Multi-Factor Authentication',
            icon: 'fa fa-lock',
            text: 'Multi-Factor Authentication',
            class: 'mfa',
            selected: options.selected == 'mfa',
            action: function show_mfa() {
                globalCh.request('show_mfa', primary);
            }
        });
    }

    if (features.notifications) {
        nav_items.splice(nav_items.length, 0, {
            id: 'notifications',
            title: 'Notification Center',
            text: 'Notification Center',
            icon: 'fa fa-bell',
            class: 'notifications',
            selected: options.selected == 'notifications-profile',
            action: function show_notifications() {
                globalCh.request('show_notifications_profile', primary);
            }
        });
    }

    if (features.show_billing) {
        nav_items.splice(1, 0, {
            id: 'account-billing',
            title: 'Account Billing',
            text: 'Billing summary for this account',
            icon: 'fa fa-usd',
            class: 'account-billing',
            selected: options.selected == 'account-billing',
            action: function show_billing() {
                globalCh.request('show_billing', primary);
            }
        });
    }
    
    nav_collection.set(nav_items);

    if (options.empty) {
        region.show(new NavView({
            collection: null
        }));
        // UX requested left nav be hidden if it is empty
        region.$el.hide();
        return;
    } else if (region.$el) {
        region.$el.show();
    }

    if ((collection !== options.collection || options.reset) || !region.collection) {
        region.show(new NavView({
            className: options.category || '',
            collection: options.collection,
            childView: options.childView,
            childViewOptions: options.childViewOptions
        }));
        collection = options.collection;
    }

}

export default show_profile_nav;
